import { Component, OnInit } from '@angular/core';
import { BoobleModalService } from 'booble-modal';
import { Clipboard } from '@angular/cdk/clipboard';
import { NotifierService } from 'angular-notifier';
import { CurrencyService } from 'src/app/shared/services/currency.service';
import { CurrencyDto } from 'src/app/domain/models/dto/currency.dto';
import { AuthenticationService } from 'src/app/shared/services';

@Component({
  selector: 'app-bank-channel-modal',
  templateUrl: './bank-channel-modal.component.html',
  styleUrls: ['./bank-channel-modal.component.scss']
})
export class BankChannelModalComponent implements OnInit {

  boobleModalData: any;
  currencyDetails?: CurrencyDto;
  private readonly notifier: NotifierService;

  get companyId() {
    return +this.accountService.getCompanyId();
  }

  constructor(
    private modalService: BoobleModalService,
    private readonly currencyService: CurrencyService,
    private clipboard: Clipboard,
    private readonly accountService: AuthenticationService,
    notifierService: NotifierService
  ) {
    this.notifier = notifierService;
  }

  ngOnInit() {
    this.getBankChannel();
  }


  closeModal() {
    this.modalService.dismiss(null);
  }

  getBankChannel() {
    this.currencyService.get(this.boobleModalData).subscribe({
      next: (result) => {
        this.currencyDetails = result.data;
      },
    });
  }

  copyText() {
    this.clipboard.copy(
      'Intermediary Bank: ' +
      this.currencyDetails?.intermediaryBankChannels[0]?.bank +
      ' Swift Code: ' +
      this.currencyDetails?.intermediaryBankChannels[0]?.swift +
      ' ccount: ' +
      this.currencyDetails?.intermediaryBankChannels[0]?.account +
      ' Address: ' +
      this.currencyDetails?.intermediaryBankChannels[0]?.address +
      ' Beneficiary Bank: ' +
      this.currencyDetails?.beneficiaryBankChannels[0]?.bank +
      ' Swift Code: ' +
      this.currencyDetails?.beneficiaryBankChannels[0]?.swift +
      ' Address: ' +
      this.currencyDetails?.beneficiaryBankChannels[0]?.address +
      ' Beneficiary Account: ' +
      this.currencyDetails?.beneficiaries[0]?.account + ' ' + this.currencyDetails?.beneficiaries[0]?.nomecliente +
      ' Reference: ' +
      this.currencyDetails?.beneficiaries[0]?.reference

    );
    this.notifier.notify('success', 'Canal bancário copiado para área de transferência');
  }

}
